import {
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_RESET,
  RESET_JOB,
} from "../../actionTypes";

export const logoutRequest = (jobData) => ({
  type: LOGOUT_REQUEST,
  payload: jobData,
});

export const logoutSuccess = (response) => ({
  type: LOGOUT_SUCCESS,
  payload: response,
});

export const logoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  payload: error,
});

export const resetLogout = () => ({
  type: LOGOUT_RESET,
});
